import EmbeddingsMaxConcurrentBatches from "./EmbeddingsMaxConcurrentBatchesField";

export default function EmbeddedSettings() {
    return <EmbeddingsMaxConcurrentBatches baseName="embeddedSettings" />;
}
